import { useEffect, useState } from "react";
import { notifyError, notifySuccess } from "../utils/toast";
import {
  handleGetRoleBasedUsers,
  handleGetContactPersons,
} from "../services/userService";
import {
  handleChangeResponsiblePerson,
  handleGetAllMeetings,
  handleGetMeetingStatusCounts,
} from "../services/routes/meetingRoute";
import ReportApi from "../Apis/ReportApi";

import { userID } from "../utils/storage";
import userModule from "../Apis/userModule";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const useMeeting = () => {
  const [data, setData] = useState([]);
  const [userCache, setUserCache] = useState(new Map());
  const [meetingPersonData, setMeetingPersonData] = useState([]);
  const [isListModelOpen, setIsListModelOpen] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [presonList, setPresonList] = useState([]);
  const [selectedId, setSelectedId] = useState();
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [nextId, setNextId] = useState("");
  const [prevId, setPrevId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [loader , setLoader] = useState(false);
  const [hasMore , setHasMore] = useState(false);
  const [statusCounts, setStatusCounts] = useState({ completed: 0, notYetStarted: 0, cancelled: 0 });


  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const fetchPage = async (cursor = "", direction = "next", pageNumber = 1) => {
    setLoading(true);
    try {
      const options = {
        limitCount: limit,
        startAfterdoc: direction === "next" ? cursor : "",
        startBeforedoc: direction === "previous" ? cursor : "",
        meetingPersonId: filters?.meetingPerson?.value || "",
        assigneeId: filters?.assistant?.value || "",
        endDate: formatDate(filters?.endDate),
        startDate: formatDate(filters?.startDate),
        status: filters?.status?.value,
        initialInfoMedium: filters?.initialInfoMedium?.value || "",
        finalInfoMedium: filters?.finalInfoMedium?.value || "",
      };
      console.log("Payload ", options);

      const response = await handleGetAllMeetings(options);
      const meetings = response?.meetings || [];
     
      const receivedFullPage = meetings.length === limit;
      const hasMoreData = receivedFullPage && !!response.lastDoc;

      console.log("hasMoreData" , hasMoreData)
  
      
      setData(meetings);
      setNextId(response?.lastDoc || "");
      setPrevId(response?.firstDoc || "");
      setHasMore(hasMoreData);
      setTotalCount(response?.totalCount || 0);
      setModalOpen(false);

      setUserCache(prev => new Map(prev).set(pageNumber, meetings));

    } catch (error) {
      console.error("Error fetching meetings:", error);
      notifyError("Failed to load meetings for the selected filters. Check the console for details.");
      setData([]);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusCounts = async () => {
    try {
      const options = {
        meetingPersonId: filters?.meetingPerson?.value || "",
        assigneeId: filters?.assistant?.value || "",
        endDate: formatDate(filters?.endDate),
        startDate: formatDate(filters?.startDate),
        initialInfoMedium: filters?.initialInfoMedium?.value || "",
        finalInfoMedium: filters?.finalInfoMedium?.value || "",
      };

      const response = await handleGetMeetingStatusCounts(options);
      setStatusCounts({
        completed: response?.completed || 0,
        notYetStarted: response?.notYetStarted || 0,
        cancelled: response?.cancelled || 0,
      });
    } catch (error) {
      console.error("Error fetching meeting status counts:", error);
    }
  };

  const loadInitial = () => {
    setUserCache(new Map());
    setCurrentPage(1);
    setNextId("");
    setPrevId("");
    setHasMore(true);
    fetchPage("", "next", 1);
  };

  const handlePageChange = (cursor, direction) => {
    if (direction === "next") {
      console.log("next ", direction);
     
      const newPage = currentPage + 1;
      if (userCache.has(newPage)) {
        setCurrentPage(newPage);
        setData(userCache.get(newPage));
        const nextPageData = userCache.get(newPage + 0 );
        console.log(nextPageData)
        setHasMore(!!nextPageData && nextPageData.length >= limit);
      } else {
        setCurrentPage(newPage);
        fetchPage(nextId, "next", newPage);
      }
    } else if (direction === "previous") {
      console.log("previous ", direction);
      const newPage = currentPage - 1;
      if (userCache.has(newPage)) {
        setCurrentPage(newPage);
        setData(userCache.get(newPage));
        console.log(userCache)
        const nextPageData = userCache.get(newPage + 0 );
        console.log(nextPageData)
        setHasMore(!!nextPageData && nextPageData.length >= limit);
      } else {
        setCurrentPage(newPage);
        fetchPage(prevId, "previous", newPage);
      }
    }
  };


 
  

  const handleReportDownload = async () => {
    setLoader(true);
    try {
      const body = {
        meetingPersonId: filters?.meetingPerson?.value || "",
        responsiblePersonId: filters?.assistant?.value || "",
        startDate: formatDate(filters?.startDate) || null,
        endDate: formatDate(filters?.endDate) || null,
        meetingStatus: filters?.status?.value || "",
      };
  
      const response = await ReportApi.getReportDownload(body);
      const meetingsData = response?.data?.meetings || [];
  
      if (meetingsData.length === 0) {
        notifyError("No meetings found");
        return;
      }
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Meetings");
  
      // Extract headers
      const headers = Object.keys(meetingsData[0]);
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
  
      // Apply styling to header row
      headerRow.eachCell((cell) => {
        cell.font = {
          bold: true,
          color: { argb: "FF399E79" }, // Green text
        };
  
      });
  
      // Add data rows
      meetingsData.forEach((item) => {
        const row = headers.map((key) => item[key]);
        worksheet.addRow(row);
      });
  
      // Auto width for columns
      worksheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell?.((cell) => {
          const cellValue = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, cellValue.length);
        });
        column.width = maxLength + 2;
      });
  
      // Export
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
  
      saveAs(blob, "Meeting_Report.xlsx");
      notifySuccess("Report downloaded successfully");
    } catch (error) {
      console.error("Error downloading report", error);
      notifyError("Error downloading report");
    } finally {
      setLoader(false);
    }
  };
  
  

  const handlePageSize = (value) => {
    setLimit(value);
    loadInitial();
  };

  const handleApplyFilters = (newFilters) => {
    const { startDate, endDate } = newFilters;

    if ((startDate && !endDate) || (!startDate && endDate)) {
      notifyError("Please select both Start Date and End Date.");
      return;
    }
  
    if (startDate !== filters.startDate || endDate !== filters.endDate) {
      
      if (startDate > endDate) {
        notifyError("Start Date cannot be after End Date.");
        return;
      }
    }
    setFilters(newFilters);
  };

  const handleClearFilters = () => {
    setFilters({});
  };


  const removeFilter = (filterKey) => {
    console.log("filterKey", filterKey);
  
    const updatedFilters = { ...filters };
  
    if (filterKey === "startDate" || filterKey === "endDate") {
      delete updatedFilters.startDate;
      delete updatedFilters.endDate;
    } else {
      delete updatedFilters[filterKey];
    }
  
    setFilters(updatedFilters);
    handleApplyFilters(updatedFilters);
  };
  

  const handleReassign = async (meetingId, id , exitingId) => {
    console.log("meetingId ", meetingId);
    console.log("id ", id);
    console.log("exitingId ", exitingId);


     const body= {
      prevAssineeId: exitingId,
          newAssigneeId : id,
          changeById: userID,
          meetingId :meetingId
        }
        setLoader(true)
    try {
      const response = await userModule.ResignMeeting(body)
      if(response.status ===  200)
      {
        notifySuccess(response?.data);
        setIsListModelOpen(false);
        setUserCache(new Map());
        loadInitial();
      }
      
    } catch (error) {
      console.error("Reassign error:", error);
      notifyError("Failed to reassign meeting. Please try again.");
    }finally{
      setLoader(false)
    }
  };

  const handleGetMeetingPerson = async () => {
    try {
      const response = await handleGetContactPersons();
      setMeetingPersonData(
        response.map((list) => ({
          value: list.id,
          label: list.name,
        }))
      );
    } catch (err) {
      console.error("Error fetching meeting persons:", err);
      notifyError("Failed to fetch meeting persons. Please try again.");
    }
  };

  const handlePresonList = async () => {
    try {
      const response = await handleGetRoleBasedUsers("");
      setPresonList(response);
    } catch (error) {
      console.error("Error fetching person list:", error);
      notifyError("Failed to fetch person list. Please try again.");
    }
  };

  useEffect(() => {
    loadInitial();
  }, [filters, limit]);

  useEffect(() => {
    fetchStatusCounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  useEffect(() => {
    handlePresonList();
    handleGetMeetingPerson();
  }, []);

  return {
    data,
    loading,
    limit,
    currentPage,
    nextId,
    prevId,
    totalCount,
    selectedMeeting,
    filters,
    setSelectedMeeting,
    presonList,
    selectedId,
    setSelectedId,
    handleReassign,
    setIsListModelOpen,
    isListModelOpen,
    meetingPersonData,
    modalOpen,
    setModalOpen,
    handlePageChange,
    handlePageSize,
    handleApplyFilters,
    handleClearFilters,
    removeFilter, 
    handleReportDownload,
    loader,
    hasMore,
    statusCounts
  };
};

export default useMeeting;